import {
  Component, EventEmitter, Input, OnChanges, OnDestroy,
  Output, SimpleChanges, ViewChild
} from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderService } from '../../services/loader/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-table',
  standalone: true,
  imports: [
    TableModule, InputIconModule, IconFieldModule, CommonModule,
    ButtonModule, TagModule, FormsModule, ReactiveFormsModule
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css',
})
export class TableComponent implements OnChanges, OnDestroy {
  @ViewChild('dt') dt!: Table;

  @Input() data!: any[];
  @Input() header!: any[];
  @Input() showPagination = true;
  @Input() selectedItem!: any;
  @Input() set deletedItems(value: any) {
    if (this.selectedItem) {
      this.selectedItem = this.selectedItem.filter((item: any) => !value.includes(item.id));
    }
  }
  @Input() recordForm!: FormGroup;
  @Input() saveData = false;
  @Input() serverSide = false;
  @Input() totalRecords!: number;
  @Input() highlightRecord!: any[];

  @Output() delete = new EventEmitter<string>();
  @Output() edit = new EventEmitter<string>();
  @Output() view = new EventEmitter<any>();
  @Output() file = new EventEmitter<any>();
  @Output() receipt = new EventEmitter<any>();
  @Output() image = new EventEmitter<any>();
  @Output() loyalty = new EventEmitter<any>();
  @Output() change = new EventEmitter<any>();
  @Output() selectedData = new EventEmitter<any>();
  @Output() selectAllData = new EventEmitter<any>();
  @Output() severData = new EventEmitter<any>();

  first = 0;
  rows = 25;
  loading = true;

  private loaderSub: Subscription;  // ✅ track subscription for cleanup

  constructor(private _loader: LoaderService) {  // ✅ removed unused Router
    this.loaderSub = this._loader.isLoading.subscribe(res => this.loading = res);
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.first = 0;  // ✅ direct assignment, no indirection through reset()
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();  // ✅ prevents subscription leak
  }

  get records(): FormArray {
    return this.recordForm.get('record') as FormArray;
  }

  onEdit(id: any): void { this.edit.emit(id); }
  onDelete(id: any): void { this.delete.emit(id); }
  onView(data: any): void { this.view.emit(data); }
  onFile(id: any): void { this.file.emit(id); }
  onReceipt(id: any): void { this.receipt.emit(id); }
  onImage(id: any): void { this.image.emit(id); }
  onLoyalty(id: any): void { this.loyalty.emit(id); }  // ✅ renamed to onLoyalty for clarity
  getServer(event: any): void { this.severData.emit(event); }

  customSort(event: any): void {
    event.data.sort((a: any, b: any) => {
      const v1 = a[event.field];
      const v2 = b[event.field];
      if (v1 == null && v2 == null) return 0;
      if (v1 == null) return -1;
      if (v2 == null) return 1;
      const result = typeof v1 === 'string'
        ? v1.localeCompare(v2)
        : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      return event.order * result;
    });
  }

  reset(): void { this.first = 0; }  // ✅ kept for template binding if needed

  pageChange(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  isLastPage(): boolean {
    return this.data ? this.first === this.data.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.data ? this.first === 0 : true;
  }

  onChange(event: any, key: any, qty: any): void {
    this.change.emit({ event, key, data: qty });
  }

  selectionAll(event: any): void {
    this.selectAllData.emit({ select: event.checked, data: this.data });
  }

  onRowSelect(event: any): void {
    this.selectedData.emit({ select: true, data: event.data });
  }

  onRowUnSelect(event: any): void {
    this.selectedData.emit({ select: false, data: event.data });
  }
}